/**
 * Pure throttle planning for live match:update → cache invalidation.
 * Caller owns timers and last-flush timestamp mutation.
 */

export interface MatchUpdateThrottlePlan {
  /** Run invalidations immediately and update lastFlushAt to nowMs */
  flushImmediately: boolean;
  /** When not immediate, schedule a single flush after this many ms */
  delayMs: number | null;
}

/**
 * @param nowMs - Current time (ms)
 * @param lastFlushMs - Last time invalidations ran; 0 means never
 * @param windowMs - Minimum gap between flushes
 */
export function planMatchUpdateThrottle(
  nowMs: number,
  lastFlushMs: number,
  windowMs: number,
): MatchUpdateThrottlePlan {
  if (windowMs <= 0) {
    return { flushImmediately: true, delayMs: null };
  }
  const since = nowMs - lastFlushMs;
  if (lastFlushMs === 0 || since >= windowMs) {
    return { flushImmediately: true, delayMs: null };
  }
  return { flushImmediately: false, delayMs: windowMs - since };
}
